<div class="atividade-tipo-select btn-group"
    [class.invalid]="!config.isValid">

    <ng-template [ngIf]="!disabled">
        <button type="button" class="btn btn-light" *ngFor="let tipo of tiposOptions" [title]="tipo.nome"
            (click)="onChange(tipo)" [class.active]="ngModel == tipo.id" [name]="name" [id]="id">
            <i [class]="tipo.icon" aria-hidden="true"></i> {{tipo.nome}}
        </button>
    </ng-template>

    <ng-template [ngIf]="disabled">
        <h5 class="mb-0">
            <i [class]="ngModel | atividadeTipoIcon" aria-hidden="true"></i>
            {{ngModel | atividadeTipo}}   
        </h5>
    </ng-template>    
</div>